module.exports = __webpack_public_path__ + "static/024.thumb-da6d32e5f1793b196e3684a20617341a.jpg";